import { API } from "aws-amplify";

const show = async params => {
  let myInit = {
    // OPTIONAL
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    queryStringParameters: params
  };
  let items = await API.get("InasakuAPI", "/inasaku/accounts", myInit);

  return items;
};

const updateAreaPos = async params => {
  let myInit = {
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    body: {
      data: params
    },
    headers: {} // OPTIONAL
  };
  let items = await API.put("InasakuAPI", "/inasaku/account-area-pos", myInit);

  return items;
};

const insert = async params => {
  let myInit = {
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    body: {
      data: params
    },
    headers: {} // OPTIONAL
  };
  await API.post("InasakuAPI", "/inasaku/signup/accounts", myInit);
};

const del = async params => {
  let myInit = {
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    body: {
      data: params
    },
    headers: {} // OPTIONAL
  };
  await API.del("InasakuAPI", "/inasaku/signup/accounts", myInit);
};

export default {
  show: show,
  updateAccountPosition: updateAreaPos,
  insert: insert,
  del: del,
};
